// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@/components';

import '@/style/components/ElfinLoading.scss';

/**
 * Elfin logo loading.
 */
export default function ElfinLoading({ className }) {
  return (
    <div className={classNames('elfin-loading', className)}>
      <div class="center">
        <Icon icon="elfin" height={37} width={228} />
      </div>
    </div>
  );
}
